import * as React from "react";
import { graphql, useStaticQuery } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

// Import layout
import Layout from "../layouts/main";

// Import components
import Hero from "../components/hero";
import Intro from "../components/intro";
import Posts from "../components/posts";
import Slider from "../components/slider";
import SEO from "../components/seo";

// Import styles
import "./styles/index.scss";

const IndexPage = () => {
  const data = useStaticQuery(graphql`
    {
      allWpPost(
        filter: { tags: { nodes: { elemMatch: { name: { eq: "featured" } } } } }
      ) {
        nodes {
          excerpt
          featuredImage {
            node {
              id
              localFile {
                childImageSharp {
                  gatsbyImageData(placeholder: TRACED_SVG, formats: AUTO)
                }
              }
            }
          }
          id
          title
          uri
        }
      }
      allWpProject(
        limit: 6
        filter: { tags: { nodes: { elemMatch: { name: { eq: "featured" } } } } }
      ) {
        nodes {
          excerpt
          featuredImage {
            node {
              id
              localFile {
                childImageSharp {
                  gatsbyImageData(placeholder: TRACED_SVG, formats: AUTO)
                }
              }
            }
          }
          id
          title
          uri
        }
      }
      wpPage(title: { eq: "Homepage" }) {
        featuredImage {
          node {
            sourceUrl
          }
        }
        homepageFields {
          intro {
            headline
            overlaidText
            video
          }
          processSection {
            title
            description
          }
          contactSection {
            title
            description
          }
        }
        seoFields {
          seo {
            description
            title
          }
        }
      }
    }
  `);

  const { allWpPost, allWpProject, wpPage } = data;
  return (
    <Layout>
      <SEO
        title={wpPage.seoFields.seo.title}
        description={wpPage.seoFields.seo.description}
        image={wpPage.featuredImage.node.sourceUrl}
      />
      <div className="homepage">
        <Intro data={wpPage} />
        <Slider data={allWpProject} />
        <Hero
          customClass="process"
          format="image-left"
          title={wpPage.homepageFields.processSection.title}
          description={wpPage.homepageFields.processSection.description}
          buttonLink="/services"
          buttonText="View Our Process"
          image={
            <StaticImage
              placeholder="TRACED_SVG"
              src="../assets/images/process-badge.png"
              alt="A badge representing Mtn Craft's process."
            />
          }
        />
        <Hero
          customClass="contact"
          format="image-right"
          title={wpPage.homepageFields.contactSection.title}
          description={wpPage.homepageFields.contactSection.description}
          buttonLink="/contact"
          buttonText="Contact Us"
          image={
            <StaticImage
              placeholder="TRACED_SVG"
              src="../assets/images/contact-badge.png"
              alt="A badge representing Mtn Craft's Contact Us call to action."
            />
          }
        />
        <Posts data={allWpPost} />
      </div>
    </Layout>
  );
};

export default IndexPage;
